module.exports = __webpack_public_path__ + "static/media/backing.646d008d.png";